import React, { useState, Component } from 'react';
import { Card } from '../components/ui/Card';
import { Tabs } from '../components/ui/Tabs';
import { Button } from '../components/ui/Button';
import { DownloadIcon, CalendarIcon, FilterIcon, BarChart2Icon, PieChartIcon, LineChartIcon, TrendingUpIcon, UsersIcon, FileTextIcon, ClockIcon, DollarSignIcon, AlertCircleIcon } from 'lucide-react';
export function Report() {
  const [dateRange, setDateRange] = useState('month');
  const handleDateRangeChange = e => {
    setDateRange(e.target.value);
  };
  // Componente di esempio per il report DSO
  const DsoReport = () => <div className="space-y-6" data-id="element-2251">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0" data-id="element-2252">
        <div data-id="element-2253">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-2254">
            DSO (Days Sales Outstanding)
          </h3>
          <p className="text-sm text-gray-500" data-id="element-2255">
            Analisi dei giorni medi di incasso per periodo e settore
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-2256">
          <Button variant="secondary" icon={<FilterIcon className="h-4 w-4 mr-2" data-id="element-2258" />} data-id="element-2257">
            Filtri
          </Button>
          <Button variant="secondary" icon={<DownloadIcon className="h-4 w-4 mr-2" data-id="element-2260" />} data-id="element-2259">
            Esporta
          </Button>
        </div>
      </div>
      <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2261">
        <div className="p-5" data-id="element-2262">
          <div className="h-64 flex items-center justify-center bg-gray-100 rounded-md" data-id="element-2263">
            <LineChartIcon className="h-16 w-16 text-gray-400" data-id="element-2264" />
            <span className="ml-3 text-gray-500" data-id="element-2265">Grafico DSO nel tempo</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-2266">
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2267">
          <div className="p-5" data-id="element-2268">
            <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-2269">
              DSO per Settore
            </h4>
            <div className="h-48 flex items-center justify-center bg-gray-100 rounded-md" data-id="element-2270">
              <BarChart2Icon className="h-12 w-12 text-gray-400" data-id="element-2271" />
              <span className="ml-3 text-gray-500" data-id="element-2272">
                Grafico DSO per settore
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2273">
          <div className="p-5" data-id="element-2274">
            <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-2275">
              Trend DSO
            </h4>
            <div className="h-48 flex items-center justify-center bg-gray-100 rounded-md" data-id="element-2276">
              <TrendingUpIcon className="h-12 w-12 text-gray-400" data-id="element-2277" />
              <span className="ml-3 text-gray-500" data-id="element-2278">Grafico trend DSO</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
  // Componente di esempio per il report Scaduti
  const ScadutiReport = () => <div className="space-y-6" data-id="element-2279">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0" data-id="element-2280">
        <div data-id="element-2281">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-2282">Analisi Scaduti</h3>
          <p className="text-sm text-gray-500" data-id="element-2283">
            Dettaglio dei crediti scaduti per periodo e cliente
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-2284">
          <Button variant="secondary" icon={<FilterIcon className="h-4 w-4 mr-2" data-id="element-2286" />} data-id="element-2285">
            Filtri
          </Button>
          <Button variant="secondary" icon={<DownloadIcon className="h-4 w-4 mr-2" data-id="element-2288" />} data-id="element-2287">
            Esporta
          </Button>
        </div>
      </div>
      <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2289">
        <div className="p-5" data-id="element-2290">
          <div className="h-64 flex items-center justify-center bg-gray-100 rounded-md" data-id="element-2291">
            <PieChartIcon className="h-16 w-16 text-gray-400" data-id="element-2292" />
            <span className="ml-3 text-gray-500" data-id="element-2293">
              Grafico scaduti per fascia temporale
            </span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-2294">
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2295">
          <div className="p-5" data-id="element-2296">
            <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-2297">
              Top 10 Clienti con Scaduti
            </h4>
            <div className="h-48 flex items-center justify-center bg-gray-100 rounded-md" data-id="element-2298">
              <BarChart2Icon className="h-12 w-12 text-gray-400" data-id="element-2299" />
              <span className="ml-3 text-gray-500" data-id="element-2300">
                Grafico top clienti con scaduti
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2301">
          <div className="p-5" data-id="element-2302">
            <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-2303">
              Scaduti per Settore
            </h4>
            <div className="h-48 flex items-center justify-center bg-gray-100 rounded-md" data-id="element-2304">
              <PieChartIcon className="h-12 w-12 text-gray-400" data-id="element-2305" />
              <span className="ml-3 text-gray-500" data-id="element-2306">
                Grafico scaduti per settore
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
  // Componente di esempio per il report Efficacia Recupero
  const RecuperoReport = () => <div className="space-y-6" data-id="element-2307">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0" data-id="element-2308">
        <div data-id="element-2309">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-2310">
            Efficacia Recupero Crediti
          </h3>
          <p className="text-sm text-gray-500" data-id="element-2311">
            Analisi dell'efficacia delle azioni di recupero crediti
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-2312">
          <Button variant="secondary" icon={<FilterIcon className="h-4 w-4 mr-2" data-id="element-2314" />} data-id="element-2313">
            Filtri
          </Button>
          <Button variant="secondary" icon={<DownloadIcon className="h-4 w-4 mr-2" data-id="element-2316" />} data-id="element-2315">
            Esporta
          </Button>
        </div>
      </div>
      <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2317">
        <div className="p-5" data-id="element-2318">
          <div className="h-64 flex items-center justify-center bg-gray-100 rounded-md" data-id="element-2319">
            <LineChartIcon className="h-16 w-16 text-gray-400" data-id="element-2320" />
            <span className="ml-3 text-gray-500" data-id="element-2321">
              Grafico efficacia recupero nel tempo
            </span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-2322">
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2323">
          <div className="p-5" data-id="element-2324">
            <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-2325">
              Efficacia per Tipo di Sollecito
            </h4>
            <div className="h-48 flex items-center justify-center bg-gray-100 rounded-md" data-id="element-2326">
              <BarChart2Icon className="h-12 w-12 text-gray-400" data-id="element-2327" />
              <span className="ml-3 text-gray-500" data-id="element-2328">
                Grafico efficacia per tipo
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2329">
          <div className="p-5" data-id="element-2330">
            <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-2331">
              Tasso di Recupero per Settore
            </h4>
            <div className="h-48 flex items-center justify-center bg-gray-100 rounded-md" data-id="element-2332">
              <PieChartIcon className="h-12 w-12 text-gray-400" data-id="element-2333" />
              <span className="ml-3 text-gray-500" data-id="element-2334">
                Grafico recupero per settore
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
  // Componente di esempio per il report Piani di Rientro
  const PianiRientroReport = () => <div className="space-y-6" data-id="element-2335">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0" data-id="element-2336">
        <div data-id="element-2337">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-2338">
            Piani di Rientro
          </h3>
          <p className="text-sm text-gray-500" data-id="element-2339">
            Analisi dell'andamento e dell'efficacia dei piani di rientro
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-2340">
          <Button variant="secondary" icon={<FilterIcon className="h-4 w-4 mr-2" data-id="element-2342" />} data-id="element-2341">
            Filtri
          </Button>
          <Button variant="secondary" icon={<DownloadIcon className="h-4 w-4 mr-2" data-id="element-2344" />} data-id="element-2343">
            Esporta
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-3" data-id="element-2345">
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2346">
          <div className="p-5" data-id="element-2347">
            <h4 className="text-base font-medium text-gray-900 mb-2" data-id="element-2348">
              Piani Attivi
            </h4>
            <div className="flex items-center" data-id="element-2349">
              <div className="text-3xl font-bold text-blue-600" data-id="element-2350">24</div>
              <div className="ml-2 text-sm text-green-600" data-id="element-2351">
                +4 nell'ultimo mese
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2352">
          <div className="p-5" data-id="element-2353">
            <h4 className="text-base font-medium text-gray-900 mb-2" data-id="element-2354">
              Tasso di Rispetto
            </h4>
            <div className="flex items-center" data-id="element-2355">
              <div className="text-3xl font-bold text-blue-600" data-id="element-2356">86%</div>
              <div className="ml-2 text-sm text-green-600" data-id="element-2357">
                +2% rispetto al periodo precedente
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2358">
          <div className="p-5" data-id="element-2359">
            <h4 className="text-base font-medium text-gray-900 mb-2" data-id="element-2360">
              Importo Medio
            </h4>
            <div className="flex items-center" data-id="element-2361">
              <div className="text-3xl font-bold text-blue-600" data-id="element-2362">€12.450</div>
              <div className="ml-2 text-sm text-red-600" data-id="element-2363">
                -5% rispetto al periodo precedente
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-2364">
        <div className="p-5" data-id="element-2365">
          <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-2366">
            Andamento Piani di Rientro
          </h4>
          <div className="h-64 flex items-center justify-center bg-gray-100 rounded-md" data-id="element-2367">
            <LineChartIcon className="h-16 w-16 text-gray-400" data-id="element-2368" />
            <span className="ml-3 text-gray-500" data-id="element-2369">
              Grafico andamento piani di rientro
            </span>
          </div>
        </div>
      </div>
    </div>;
  return <div className="space-y-6 pb-16" data-id="element-2370">
      <div data-id="element-2371">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2372">Report</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-2373">
          Analisi dettagliate sull'andamento dei crediti e delle attività di
          recupero
        </p>
      </div>
      {/* Selettore periodo */}
      <Card data-id="element-2374">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0" data-id="element-2375">
          <div className="flex items-center" data-id="element-2376">
            <CalendarIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-2377" />
            <span className="text-sm font-medium text-gray-700" data-id="element-2378">
              Periodo di analisi:
            </span>
          </div>
          <div className="flex space-x-3" data-id="element-2379">
            <select className="mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" value={dateRange} onChange={handleDateRangeChange} data-id="element-2380">
              <option value="month" data-id="element-2381">Ultimo mese</option>
              <option value="quarter" data-id="element-2382">Ultimo trimestre</option>
              <option value="halfyear" data-id="element-2383">Ultimo semestre</option>
              <option value="year" data-id="element-2384">Ultimo anno</option>
              <option value="custom" data-id="element-2385">Personalizzato</option>
            </select>
            {dateRange === 'custom' && <div className="flex space-x-2" data-id="element-2386">
                <input type="date" className="mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-2387" />
                <input type="date" className="mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-2388" />
              </div>}
          </div>
        </div>
      </Card>
      {/* Dashboard di riepilogo */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-2389">
        <Card data-id="element-2390">
          <div className="flex items-center" data-id="element-2391">
            <div className="flex-shrink-0 p-3 rounded-md bg-blue-50 text-blue-400" data-id="element-2392">
              <ClockIcon className="h-6 w-6" data-id="element-2393" />
            </div>
            <div className="ml-4" data-id="element-2394">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-2395">DSO Medio</h3>
              <div className="mt-1 flex items-baseline" data-id="element-2396">
                <p className="text-2xl font-semibold text-gray-900" data-id="element-2397">
                  45 giorni
                </p>
                <p className="ml-2 text-sm font-medium text-red-600" data-id="element-2398">
                  +3 giorni
                </p>
              </div>
            </div>
          </div>
        </Card>
        <Card data-id="element-2399">
          <div className="flex items-center" data-id="element-2400">
            <div className="flex-shrink-0 p-3 rounded-md bg-red-50 text-red-400" data-id="element-2401">
              <AlertCircleIcon className="h-6 w-6" data-id="element-2402" />
            </div>
            <div className="ml-4" data-id="element-2403">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-2404">
                Totale Scaduti
              </h3>
              <div className="mt-1 flex items-baseline" data-id="element-2405">
                <p className="text-2xl font-semibold text-gray-900" data-id="element-2406">€180.000</p>
                <p className="ml-2 text-sm font-medium text-red-600" data-id="element-2407">+12%</p>
              </div>
            </div>
          </div>
        </Card>
        <Card data-id="element-2408">
          <div className="flex items-center" data-id="element-2409">
            <div className="flex-shrink-0 p-3 rounded-md bg-green-50 text-green-400" data-id="element-2410">
              <DollarSignIcon className="h-6 w-6" data-id="element-2411" />
            </div>
            <div className="ml-4" data-id="element-2412">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-2413">Recuperato</h3>
              <div className="mt-1 flex items-baseline" data-id="element-2414">
                <p className="text-2xl font-semibold text-gray-900" data-id="element-2415">€85.500</p>
                <p className="ml-2 text-sm font-medium text-green-600" data-id="element-2416">+15%</p>
              </div>
            </div>
          </div>
        </Card>
        <Card data-id="element-2417">
          <div className="flex items-center" data-id="element-2418">
            <div className="flex-shrink-0 p-3 rounded-md bg-purple-50 text-purple-400" data-id="element-2419">
              <UsersIcon className="h-6 w-6" data-id="element-2420" />
            </div>
            <div className="ml-4" data-id="element-2421">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-2422">
                Clienti con Scaduti
              </h3>
              <div className="mt-1 flex items-baseline" data-id="element-2423">
                <p className="text-2xl font-semibold text-gray-900" data-id="element-2424">48</p>
                <p className="ml-2 text-sm font-medium text-red-600" data-id="element-2425">+5</p>
              </div>
            </div>
          </div>
        </Card>
      </div>
      {/* Tab con i vari report */}
      <Tabs tabs={[{
      id: 'dso',
      name: 'DSO',
      content: <DsoReport data-id="element-2427" />
    }, {
      id: 'scaduti',
      name: 'Analisi Scaduti',
      content: <ScadutiReport data-id="element-2428" />
    }, {
      id: 'recupero',
      name: 'Efficacia Recupero',
      content: <RecuperoReport data-id="element-2429" />
    }, {
      id: 'piani',
      name: 'Piani di Rientro',
      content: <PianiRientroReport data-id="element-2430" />
    }]} data-id="element-2426" />
    </div>;
}